import { styled } from '@mui/material';

export const H5 = styled('h5')<{ margin?: 'none' | 'normal' }>(
    ({ theme, margin }) => ({
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '16px',
        margin: margin === 'none' ? null : '0 0 16px 0',
        color: theme.palette.text.primary,
        padding: 0,
        [theme.breakpoints.up('sm')]: {},
    }),
);
